module.exports = __webpack_public_path__ + "img/fc.165ab5f0.svg";